import "./statistics-row.scss";

import { CSSProperties } from "react";
import cn from "clsx";
import { Alignment } from "design-system/types/types";
import { Theme } from "design-system/utils/theme";
import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import {
  Statistic,
  StatisticProps,
} from "design-system/components/primitives/statistic/statistic";

export interface StatisticsRowProps {
  headerContent?: ComponentHeaderProps;
  statistics: Array<StatisticProps>;
  statsPerRow?: number;
  statsWrap?: boolean;
  align?: Alignment;
  theme?: Theme;
  HeadingLevel?: "h2" | "h3";
}

export function StatisticsRow({
  headerContent,
  statistics,
  statsPerRow,
  statsWrap,
  align = "wide",
  theme = "crimson",
  HeadingLevel,
}: StatisticsRowProps) {
  if (!statistics || statistics?.length === 0) {
    return null;
  }

  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-statistics-row",
    statsWrap && `hbs-statistics-row--wrap`,
  );

  const numberOfStats = statistics?.length;
  const displayStatsPerRow =
    statsPerRow && statsPerRow < numberOfStats ? statsPerRow : numberOfStats;
  const rowClass = cn(
    "hbs-statistics-row__list",
    `hbs-statistics-row__list--${numberOfStats}-items`,
    statsPerRow && `hbs-tease-row--${displayStatsPerRow}-up`,
  );

  return (
    <div className={wrapperClass}>
      {headerContent && (
        <ComponentHeader {...headerContent} HeadingLevel={HeadingLevel} />
      )}

      {statistics && (
        <ul
          className={rowClass}
          style={
            {
              "--columns": String(displayStatsPerRow),
            } as CSSProperties
          }
        >
          {statistics.map((stat, i) => (
            <li key={i} className="hbs-statistics-row__item" data-theme={theme}>
              <Statistic {...stat} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
